<template>
    <router-view />
    <Footer />
</template>
<script setup>
// import Header from "@/components/HeaderCom.vue";
import Footer from "@/components/FooterCom.vue";
</script>
<style>
#app {
    font-family: Alexandria, Alexandria;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #FFFFFF;
}
</style>
